import { useState } from "react";
import { Card, CardContent } from "../../../client/components/ui/card";
import { CardSectionHeader } from "../../../client/components/ui/card-section-header";
import { usePfmData } from "../../../prop-firm-manager/PfmDataContext";
import PayoutsAnalyticsSection from "../../../prop-firm-manager/PayoutsAnalyticsSection";
import useTranslation from "../../../client/hooks/useTranslation";

type Granularity = "month" | "quarter" | "year";

export default function PropFirmReportingWidget() {
  const { filteredAccounts, isDark } = usePfmData();
  const t = useTranslation();
  const [granularity, setGranularity] = useState<Granularity>("month");

  const btnBase = "px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors";
  const btnActive = isDark
    ? "bg-primary/20 text-primary border border-primary/40"
    : "bg-primary/15 text-primary border border-primary/30";
  const btnInactive = isDark
    ? "text-gray-400 hover:bg-white/5 border border-transparent"
    : "text-gray-500 hover:bg-gray-100 border border-transparent";

  const granOptions: { value: Granularity; label: string }[] = [
    { value: "month", label: t.analytics.reportGranMonth },
    { value: "quarter", label: t.analytics.reportGranQuarter },
    { value: "year", label: t.analytics.reportGranYear },
  ];

  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader
        label={t.analytics.reportTitle}
        isDark={isDark}
        compact
        rightContent={
          <div className="flex items-center gap-1">
            {granOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => setGranularity(opt.value)}
                className={`${btnBase} ${granularity === opt.value ? btnActive : btnInactive}`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        }
      />
      <CardContent className="px-4 pb-4 pt-0 flex-1 overflow-auto">
        <PayoutsAnalyticsSection
          accounts={filteredAccounts}
          isDark={isDark}
          sections={{ reporting: true, accountsTable: false, globalCharges: false }}
          hideTitle
          granularityOverride={granularity}
        />
      </CardContent>
    </Card>
  );
}
